import React, { ReactNode } from 'react';
interface SectionHeaderProps {
  id?: string;
  title: ReactNode;
  intro?: ReactNode;
  tone?: 'light' | 'dark';
  className?: string;
}
export function SectionHeader({
  id,
  title,
  intro,
  tone = 'light',
  className = ''
}: SectionHeaderProps) {
  return <div className={`max-w-2xl ${className}`} data-id="element-558" data-mp="22fzd3gbuspks">
      <h2 id={id} className={`font-sora text-[2rem] font-semibold leading-[1.1] tracking-[-0.02em] md:text-[2.75rem] ${tone === 'light' ? 'text-afb-ink' : 'text-white'}`} data-id="element-559" data-mp="27hygurbi9oi9">
        {title}
      </h2>
      {intro && <p className={`mt-4 text-lg leading-relaxed ${tone === 'light' ? 'text-afb-muted' : 'text-white/70'}`} data-id="element-560" data-mp="2l8bmgn0xcr4f">
          {intro}
        </p>}
    </div>;
}